import React from 'react';
import SiriTransitionBall from './SiriTransitionBall';
import { useVoice } from '../context/VoiceContext';
import { FaMicrophone, FaMicrophoneSlash } from 'react-icons/fa';

const VoiceBallOverlay = ({
  isVisible,
  voiceState = 'listening',
  isVoiceActive = false,
  onEndCall
}) => {
  const { micAmplitude, isMuted, toggleMute } = useVoice();

  // Log to see if micAmplitude is updating
  // console.log("🎤 VoiceBallOverlay micAmplitude:", micAmplitude);

  if (!isVisible) return null;

  return (
    <>
      {/* Fullscreen overlay background */}
      <div className="voice-ball-overlay">
        <div className="voice-overlay-background" />
      </div>

      {/* Ball centered independently - outside overlay */}
      <div className="voice-ball-container">
        <SiriTransitionBall
          size={150}
          isVoiceActive={isVoiceActive}
          voiceState={voiceState}
          isOverlay={false}
          isDraggable={false}
          amplitude={micAmplitude}
        />
      </div>

      {/* X button at bottom left */}
      <div className="voice-end-button-container">
        <button
          className="voice-end-button"
          onClick={onEndCall}
          aria-label="End voice chat"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      {/* Mic toggle button at bottom right */}
      <div className="voice-mic-button-container">
        <button
          className={`voice-mic-button ${isMuted ? 'muted' : ''}`}
          onClick={toggleMute}
          aria-label={isMuted ? "Unmute microphone" : "Mute microphone"}
        >
          {isMuted ? (
            <FaMicrophoneSlash size={20} />
          ) : (
            <FaMicrophone size={20} />
          )}
        </button>
      </div>
    </>
  );
};

export default VoiceBallOverlay;